module.exports = __webpack_public_path__ + "static/media/lobby.04aca590.jpg";